import { AdjacentType, isNonNaNNumber, objectsMatch } from '@iotv/iotv-v3-types';
import { DeviceConfig, isDeviceConfig, isRollingPatternDisabledConfig, } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
export function getScheduleContextInfo({ scheduler, entity, nodeEdgeMapper, rollingProgramme }) {
    let broadcastDataMatches = false;
    let requestedConfigMatches = false;
    let reportedConfigMatches = false;
    let enabledStateMatches = false;
    let persistedProgramedEnabled = rollingProgramme?.enabled ?? false;
    let requestedProgrammeEnabled = false;
    let reportedProgammeEnabled = false;
    let requestIsInFlight = false;
    /** the configured context as per the UI */
    const schedulerContext = scheduler.context;
    const schedulerRollingProgramme = scheduler.rollingProgramme;
    enabledStateMatches = rollingProgramme?.enabled === scheduler.lastPersitedState?.rollingProgramme.enabled;
    let lastUpdated = null;
    try {
        const schedulerHasItem = !!scheduler.context.getItem(entity);
        if (schedulerHasItem) {
            const window = scheduler.getWindowForItem(entity);
            if (window) {
                const thisRollingProgrammeSchedule = schedulerRollingProgramme.getRollingProgrammeConfigForWindowIdx(window.windowIdx);
                const devices = schedulerContext.getNodesByPath(entity, [{ adjacencyType: AdjacentType.CHILD, objectTypeId: 'Device' }]);
                if (devices.length === 0) {
                    console.log(`WARN: NO DEVICES!`, schedulerContext.getSummary());
                }
                if (devices.length === 1) {
                    const currentDeviceConfig = nodeEdgeMapper.getItem(DeviceConfig.createForDevice(devices.at(0)));
                    if (isDeviceConfig(currentDeviceConfig)) {
                        const { reported, requested, metadata, lastReportedMs, lastRequestedMs, lastRequestedBroadcastScheduleSk } = currentDeviceConfig;
                        if (isNonNaNNumber(metadata?.lastUpdatedMs)) {
                            lastUpdated = metadata.lastUpdatedMs;
                        }
                        /** broadcastData */
                        const broadcastScheduleMatches = rollingProgramme?.sk === lastRequestedBroadcastScheduleSk;
                        const broadcastTimeNewer = rollingProgramme?.appliedTimestampsMs?.[0] !== undefined && rollingProgramme?.appliedTimestampsMs?.[0] <= (lastUpdated ?? 0);
                        broadcastDataMatches = broadcastScheduleMatches && broadcastTimeNewer;
                        if (requested) {
                            const { rollingPatternMode } = requested;
                            requestedConfigMatches = objectsMatch(thisRollingProgrammeSchedule ?? { never: true }, rollingPatternMode);
                            requestedProgrammeEnabled = !isRollingPatternDisabledConfig(rollingPatternMode);
                        }
                        if (reported) {
                            const { scheduleReport } = reported;
                            if (scheduleReport) {
                                const { rollingPatternConfig } = scheduleReport;
                                reportedConfigMatches = objectsMatch(thisRollingProgrammeSchedule ?? { never: true }, rollingPatternConfig);
                                reportedProgammeEnabled = !isRollingPatternDisabledConfig(rollingPatternConfig);
                            }
                        }
                        if (requested && reported) {
                            const { rollingPatternMode } = requested;
                            const { scheduleReport } = reported;
                            if (scheduleReport) {
                                const { rollingPatternConfig } = scheduleReport;
                                reportedConfigMatches = objectsMatch(thisRollingProgrammeSchedule ?? { never: true }, rollingPatternConfig);
                                reportedProgammeEnabled = !isRollingPatternDisabledConfig(rollingPatternConfig);
                                requestIsInFlight = objectsMatch(rollingPatternMode, rollingPatternConfig);
                            }
                        }
                        // debug && console.log(`INFO  ScheduleStatus evaluated:`,{ thisS: thisRollingProgrammeSchedule, requested, reported, lastUpdated: lastUpdated?.valueOf() })
                    }
                    else {
                        debug && console.log(`WARN: ScheduleStatus, no deviceConfig for `, { entity, devices });
                    }
                }
                if (devices.length > 1) {
                    console.log(`WARN: more than one device retreived, not supporting this here`);
                }
            }
            else {
                debug && console.log(`WARN: ScheduleStatus, no window for `, { entity });
            }
        }
    }
    catch (e) {
        debug && console.log(`ERROR extracting schedule context info for entity ${entity.sk} with error:`, e);
    }
    return {
        broadcastDataMatches,
        requestedConfigMatches,
        reportedConfigMatches,
        enabledStateMatches,
        persistedProgramedEnabled,
        reportedProgammeEnabled,
        requestedProgrammeEnabled,
        requestIsInFlight,
    };
}
